import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { formatResourcePath } from 'src/utils/regex';

import type { Event } from 'src/features/events/types/event';
import type { InfiniteQueryConfig, QueryConfig } from 'src/lib/react-query';
import type { ListDTO, ListResponseSmartParkAPI } from 'src/types';

const RESOURCE = '/parkings/:parkingId/events/';

type ListEventsQueryFnType = typeof listEvents;

interface ListEventsDTO extends ListDTO {
    parkingId: string;
    date_greater_than?: string;
    date_less_than?: string;
}

interface UseListEventsInfiniteOptions extends ListEventsDTO {
    config?: InfiniteQueryConfig<ListEventsQueryFnType>;
}

interface UseListEventsOptions extends ListEventsDTO {
    config?: QueryConfig<ListEventsQueryFnType>;
}

export const listEvents = ({ parkingId, ...params }: ListEventsDTO): Promise<ListResponseSmartParkAPI<Event>> => {
    // Custom core filtering
    Object.entries(params).map(([key, value]) => {
        if (Array.isArray(value)) params[key] = params[key].join(',');
    });

    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

export const useGetEventsInfinite = ({ config, ...params }: UseListEventsInfiniteOptions) =>
    useInfiniteQuery({
        queryKey: ['allEvents', ...Object.values(params)],
        queryFn: async () => await listEvents(params),
        initialPageParam: 0,
        getNextPageParam: (lastPage) => lastPage.offset + (params?.limit ?? 0), // Remove the unused allPages parameter
        ...config,
    });

export const useGetEvents = ({ config, ...params }: UseListEventsOptions) =>
    useQuery({
        queryKey: ['allEvents', ...Object.values(params)],
        queryFn: async () => await listEvents(params),
        ...config,
    });
